// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__erKpt","info":"PatientInfo_info__3sVrK"};